import { stringToHexColor } from '@/utils/functions/stringToHexColor';
import { Avatar, AvatarProps } from 'antd';
import { FaUser } from 'react-icons/fa';

interface Props extends AvatarProps {
  name: string;
  id?: number;
}

export default function EntityAvatar({ id, name, ...props }: Props) {
  const hex = stringToHexColor((id || name || 'Default').toString());

  return (
    <Avatar {...props} style={{ color: hex.color, background: hex.background }}>
      {name && name.slice(0, 2)}
      {!name && <FaUser size={12} />}
    </Avatar>
  );
}
